import { Component, ElementRef, OnInit, ViewChild, signal, WritableSignal } from '@angular/core';
import { OilCollectionDetailsComponent } from './modals/oil-collection-details/oil-collection-details.component';

import { RemoteOilCollectionModalComponent } from './modals/remote-oil-collection-modal/remote-oil-collection-modal.component';
import { OilCollectionService } from '../../../services/customers/oil-collection.service';
import { OilCollectionModel } from '../../../models/customers/oil-collection.model';
import { User } from '../../../models/user.model';

// Tier 8: Wijmo imports removed (CellMaker / CollectionView / wjcGrid / wjcCore /
// wjcInput / wjcGridXlsx). AG Grid vía KiteGridComponent hace el rendering.
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { Calculates } from '../../../utilities/calculateWaste';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { ZapierService } from '../../../services/helpers/zapier.service';
import { EmailTemplate } from '../../../constants/email-template';
import { UsuarioService } from '../../../services/usuario.service';
import { ClientsService } from '../../../services/customers/clients.service';
import { PdfUtilities } from '../../../utilities/pdf/pdf.utilities';

import { GlobalRequest } from '../../../services/global/presenter/global.request';
import { GlobalPresenter } from '../../../services/global/presenter/global.presenter';
import { DialogsService } from '../../../services/dialogs.service';
import { DateFilterValue } from 'src/app/shared/widgets/document-viewer/components/date-filter/date-filter.component';
import { StatusFilterOption } from 'src/app/shared/widgets/filter-by/filter-by.component';
import { parseDateInput, toDateOnly } from '../../../utilities/format-date';
import { AddRouteModalComponent } from '../../../shared/widgets/routes/add-route-modal/add-route-modal.component';

// Tier 8: column-utils for AG Grid factory helpers (replaces inline cellRenderers
// for the Status badge column and the action button column).
import {
  createActionColumn,
  createBadgeColumn,
  createPlainColumn,
  createTitlecaseColumn
} from '../../../shared/components/kite-grid/column-utils/column-utils';

const pdfMakeAny: any = (pdfMake as any).default || pdfMake;
pdfMakeAny.vfs = (pdfFonts as any)?.pdfMake?.vfs || (pdfFonts as any)?.vfs || (pdfFonts as any)?.default || pdfFonts;

export enum ViewMode {
  COLLECTIONS = 'collections',
  ROUTES = 'routes'
}


@Component({
  selector: 'app-oil-collection',
  templateUrl: './oil-collection.component.html',
  styleUrls: ['./oil-collection.component.scss'],
  standalone: false
})
export class OilCollectionComponent implements OnInit {
  // Tier 8: ViewChild 'flex' / 'flexclone' / 'routesFlex' / 'clientsAuto' removed —
  // the AG Grid instances live inside KiteGridComponent and we don't need typed
  // references to Wijmo FlexGrid anywhere in this component anymore.
  @ViewChild('input', { static: true }) input!: ElementRef;

  ViewMode = ViewMode;
  viewMode: ViewMode = ViewMode.COLLECTIONS;

  toggleView(mode: ViewMode) {
    this.viewMode = mode;
  }

  totalRecords: WritableSignal<number> = signal(0);
  totalPages: WritableSignal<number> = signal(0);
  loading = signal(true);
  loadingTable = signal(false);
  loadingExport = signal(false);

  // Tier 8: ViewChild('routesFlex') removed — wj-flex-grid #routesFlex is gone.
  totalRoutesRecords: WritableSignal<number> = signal(0);
  loadingRoutesTable = signal(false);
  // Tier 8: `routesPaginationArr` (CollectionView) removed.
  routePage: number = 1;
  routePageSize: number = 21;
  routeTabletSearchTerm: string = '';
  routeFilter: any = {};

  oilCollectionForm!: UntypedFormGroup;
  message = '';
  // Tier 8: `datos_arr_Tmp` / `datos_arr` removed (only used by the deleted
  // _sortData/_transformData/_isInRange helpers).
  // Tier 8: `pagination_arr` (CollectionView) removed.
  collectionsColumnDefs: any[] = [];
  routesColumnDefs: any[] = [];
  collectionsGridOptions: any = {};
  routesGridOptions: any = {};
  readonly collectionsRowData = signal<any[]>([]);
  readonly routesRowData = signal<any[]>([]);
  formSubmitted = false;
  titulo: boolean = true;
  resultCalculateWaste!: number;

  collectionSize: number = 0;
  page: number = 1;
  pageSize: number = 21;
  maxSize: number = 5;

  oilCollection!: OilCollectionModel;

  pdfUtilities: PdfUtilities = new PdfUtilities();
  calculatesWate: Calculates = new Calculates();
  files_arr: File[] = [];

  filter: any = {};
  filter_options: Array<StatusFilterOption> = [
    { field: 'notes', value: 'all', label: 'All' },
    { field: 'notes', value: 'with_note', label: 'With Notes' },
    { field: 'notes', value: 'without_note', label: 'Without Notes' },
  ];
  selected_values: any[] = [];
  tabletSearchTerm: string = '';

  usuario!: User;

  routes: any = [];
  clients: any = [];

  isAscending: boolean = false;

  private requestGlobal: GlobalRequest;

  // Tier 8: tplInfoBtn / tplDeleteBtn / tplPdfBtn / tplEmailBtn CellMaker templates removed
  // — never used in the rendered template (their bindings were inside *ngIf="false"
  // blocks guarded by `disabled in DOM`).

  constructor(
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private oilCollectionService: OilCollectionService,
    private zapierService: ZapierService,
    private globalPresenter: GlobalPresenter,
    private clientService: ClientsService,
    private dialogsService: DialogsService,
    private router: Router
  ) {
    this.requestGlobal = globalPresenter;
    globalPresenter.setComponent(this);
  }

  ngOnInit(): void {
    this.cargarDatos();
    this.crearFormularioOilCollection(null, 'new');
    this.usuario = this.requestGlobal.getUser();
    this.initAgGrid();

    this.clientService.getAllAsync().then((records: any) => {
      this.clients = records.clients;
    });

    this.cargarDatosRutas();
  }

  // ── Column definitions (AG Grid, replaces inline wijmo FlexGrid) ──────────
  initAgGrid(): void {
    // Collections grid: action column with 4 buttons (gated by permissions).
    this.collectionsColumnDefs = [
      createActionColumn({
        width: 160,
        buttons: this.buildCollectionsActionButtons()
      }),
      createPlainColumn({
        field: 'ident_GUI',
        headerName: 'Client ID',
        width: 100,
        cellClass: 'ag-cell-center'
      }),
      createTitlecaseColumn({
        field: 'name_client_address',
        headerName: 'Client Name',
        flex: 1,
        minWidth: 200,
        cellClass: 'ag-cell-left'
      }),
      createPlainColumn({
        field: 'date',
        headerName: 'Collection Date',
        width: 200,
        cellClass: 'ag-cell-center'
      }),
      createPlainColumn({
        field: 'gallons',
        headerName: 'Gross Oil Volume',
        width: 180,
        cellClass: 'ag-cell-center'
      }),
      createPlainColumn({
        field: 'driver',
        headerName: 'Driver Name',
        width: 200,
        cellClass: 'ag-cell-left'
      })
    ];

    // Routes grid: action column with single "info" button + custom badge column
    // for the Status.
    this.routesColumnDefs = [
      createActionColumn({
        width: 80,
        buttons: [
          {
            icon: 'fa-eye',
            title: 'View route',
            ariaLabel: 'view route',
            classes: 'info-route-btn'
          }
        ]
      }),
      createPlainColumn({
        field: 'route_no_display',
        headerName: 'Route ID',
        width: 200,
        cellClass: 'ag-cell-center'
      }),
      createTitlecaseColumn({
        field: 'driver_name',
        headerName: 'Driver Name',
        flex: 1,
        minWidth: 200,
        cellClass: 'ag-cell-left'
      }),
      createPlainColumn({
        field: 'date',
        headerName: 'Route Date',
        width: 200,
        cellClass: 'ag-cell-center'
      }),
      createPlainColumn({
        field: 'clients_count',
        headerName: 'Total Clients',
        width: 120,
        cellClass: 'ag-cell-center'
      }),
      createPlainColumn({
        field: 'total_gallons',
        headerName: 'Total Gallons',
        width: 180,
        cellClass: 'ag-cell-center'
      }),
      createBadgeColumn({
        field: 'status_label',
        headerName: 'Status',
        width: 180,
        dotClass: (item: any) =>
          (item.status === '2' || item.status_label === 'Completed') ? 'dot-complete' : 'dot-warning',
        text: (item: any) =>
          (item.status === '2' || item.status_label === 'Completed') ? 'COMPLETED' : 'IN PROGRESS'
      })
    ];

    this.collectionsGridOptions = {};
    this.routesGridOptions = {};

    this.collectionsGridOptions = {
      // Wire wrapper's cellClicked to the same handler used by the legacy inline
      // cellRenderers (info/pdf/email/delete).
      onCellClicked: (event: any) => {
        const target = event?.event?.target as HTMLElement | undefined;
        const button = target?.closest('button');
        if (!button) return;
        const row = event.data;
        if (button.classList.contains('info-btn')) {
          this.infoGridRow(row);
        } else if (button.classList.contains('pdf-btn')) {
          this.getpdfGridRow(row);
        } else if (button.classList.contains('email-btn')) {
          this.resendGridRow(row);
        } else if (button.classList.contains('delete-btn')) {
          this.deleteGridRow(row);
        }
      }
    };

    this.routesGridOptions = {
      onCellClicked: (event: any) => {
        const target = event?.event?.target as HTMLElement | undefined;
        const button = target?.closest('button');
        if (button && button.classList.contains('info-route-btn')) {
          this.infoRouteGridRow(event.data);
        }
      }
    };
  }

  /** Helper: builds the action-buttons array for the collections grid,
   *  applying permission gates inline. */
  private buildCollectionsActionButtons() {
    return [
      {
        icon: 'fa-eye',
        title: 'View info',
        ariaLabel: 'view info',
        classes: 'info-btn'
      },
      ...(this.usuario?.hasPermission?.('oilRecovery', 'downloadOilPdf')
        ? [{
            icon: 'fa-file-pdf-o',
            title: 'Download PDF',
            ariaLabel: 'download PDF',
            classes: 'pdf-btn'
          }] : []),
      ...(this.usuario?.hasPermission?.('oilRecovery', 'sendOilPdfEmail')
        ? [{
            icon: 'fa-envelope',
            title: 'Send PDF by email',
            ariaLabel: 'send PDF by email',
            classes: 'email-btn'
          }] : []),
      ...(this.usuario?.hasPermission?.('oilRecovery', 'delete')
        ? [{
            icon: 'fa-trash',
            title: 'Delete',
            ariaLabel: 'delete',
            classes: 'delete-btn'
          }] : [])
    ];
  }

  // ── Action handlers (called from wrapper's onCellClicked) ─────────────────

  infoGridRow(row: any) {
    const modalRef = this.modalService.open(OilCollectionDetailsComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      centered: true,
      scrollable: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.oilCollection = row;
    modalRef.result.then((shouldReload) => {
      if (shouldReload) {
        this.cargarDatos();
      }
    }, () => { });
  }

  getpdfGridRow(row: any) {
    this.getPDF_File_Download(row);
  }

  resendGridRow(row: any) {
    this.getOilCertificateByEmail(row);
  }

  deleteGridRow(row: any) {
    this.dialogsService.openConfirmationModal({
      title: 'DELETE OIL RECOVERY',
      msg: `Do you want to Delete ${row.client?.name_client?.toUpperCase()} Located at ${row.client?.address?.toUpperCase()} of ${row.client?.city} City?`,
      confirmText: 'Yes, Delete it!',
      onConfirm: () => {
        this.deleteOilCollection(null, row);
      }
    });
  }

  infoRouteGridRow(row: any) {
    if (row && row._id) {
      this.router.navigate(['/uco/route', row._id]);
    }
  }

  // ── Data loading ─────────────────────────────────────────────────────────

  async cargarDatos() {
    this.message = '';
    const params: any = {
      limit: this.pageSize,
      page: this.page
    };

    if (this.tabletSearchTerm) {
      params.search = this.tabletSearchTerm;
    }

    if (this.filter.start && this.filter.end) {
      params.startDate = this.filter.start;
      params.endDate = this.filter.end;
    }

    const hasWithNote = this.selected_values.some(o => o.value === 'with_note');
    const hasWithoutNote = this.selected_values.some(o => o.value === 'without_note');
    if (hasWithNote && !hasWithoutNote) {
      params.hasNotes = true;
    } else if (!hasWithNote && hasWithoutNote) {
      params.hasNotes = false;
    }

    try {
      const resp: any = await this.oilCollectionService.getAllPaginated(params);
      const data = resp?.oilcollections ?? [];
      this.totalPages.set(resp?.totalPages ?? 0);
      this.totalRecords.set(resp?.total ?? 0);
      this.collectionSize = resp?.total ?? 0;
      // Tier 8: pass the data directly to the wrapper (no CollectionView wrapping).
      this.collectionsRowData.set(this.transformCollections(data));
    } catch {
      this.totalRecords.set(0);
      this.collectionsRowData.set([]);
    } finally {
      this.loading.set(false);
      this.loadingTable.set(false);
    }
  }

  /** Tier 8: replaces `_getData(arr)` + CollectionView wrapping.
   *  Pure data transform that the AG Grid wrapper reads via [rowData]. */
  private transformCollections(arr: any[]): any[] {
    return arr.map((item: any) => ({
      ...item,
      driver: item.route?.driver?.name,
      name_client_address: item.client?.name_client_address,
      ident_GUI: item.client?.ident_GUI,
      date: this.formatDate(item.created_at, 'MM/dd/yyyy')
    }));
  }

  async refreshData() {
    this.loadingTable.set(true);
    await this.cargarDatos();
  }

  onDateFilterChange(value: DateFilterValue) {
    if (!value || value.type === 'none') {
      this.filter.start = undefined;
      this.filter.end = undefined;
      this.applyFilters();
      return;
    }
    this.filter.start = value.startDate;
    this.filter.end = value.endDate;
    this.applyFilters();
  }

  async applyFilters() {
    if (!this.loading()) {
      this.loadingTable.set(true);
    }
    this.page = 1;
    await this.cargarDatos();
  }

  onTabletSearch(term: string) {
    this.tabletSearchTerm = term;
    this.applyFilters();
  }

  onStatusFilter(optionOrArray: any) {
    if (Array.isArray(optionOrArray)) {
      this.selected_values = optionOrArray;
    } else {
      this.selected_values = [optionOrArray];
    }
    this.applyFilters();
  }

  /** Tier 8: replaces `wjcCore.Globalize.format(new Date(date), format)` with
   *  an Intl-based formatter anchored to America/New_York so that date/day
   *  values are always correct regardless of server or browser system timezone.
   *  Fixes the 4-hour UTC offset bug for collections registered after 8 PM EDT
   *  (where UTC date rolls over to the next calendar day). */
  formatDate(date: string | Date, format: string): string {
    const d = new Date(date instanceof Date ? date.getTime() : date);
    if (isNaN(d.getTime())) return '';
    const tz = 'America/New_York';
    switch (format) {
      case 'MM/dd/yyyy': {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz, month: '2-digit', day: '2-digit', year: 'numeric'
        }).formatToParts(d);
        const p: Record<string, string> = {};
        parts.forEach(({ type, value }) => { p[type] = value; });
        return `${p['month']}/${p['day']}/${p['year']}`;
      }
      case 'MM/dd/yyyy HH:mm': {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz, month: '2-digit', day: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(d);
        const p: Record<string, string> = {};
        parts.forEach(({ type, value }) => { p[type] = value; });
        return `${p['month']}/${p['day']}/${p['year']} ${p['hour']}:${p['minute']}`;
      }
      default:
        return new Intl.DateTimeFormat('en-US', { timeZone: tz }).format(d);
    }
  }

  // ── Routes ───────────────────────────────────────────────────────────────

  onRouteSearch(term: string) {
    this.routeTabletSearchTerm = term;
    this.applyRouteFilters();
  }

  onRouteDateFilterChange(value: DateFilterValue) {
    if (!value || value.type === 'none') {
      this.routeFilter.start = undefined;
      this.routeFilter.end = undefined;
      this.applyRouteFilters();
      return;
    }
    this.routeFilter.start = value.startDate;
    this.routeFilter.end = value.endDate;
    this.applyRouteFilters();
  }

  async applyRouteFilters() {
    this.loadingRoutesTable.set(true);
    this.routePage = 1;
    await this.cargarDatosRutas();
  }

  async refreshRoutesData() {
    this.loadingRoutesTable.set(true);
    await this.cargarDatosRutas();
  }

  async cargarDatosRutas() {
    const params: any = {
      limit: this.routePageSize,
      page: this.routePage
    };
    if (this.routeTabletSearchTerm) {
      params.search = this.routeTabletSearchTerm;
    }
    if (this.routeFilter.start && this.routeFilter.end) {
      params.startDate = this.routeFilter.start;
      params.endDate = this.routeFilter.end;
    }

    try {
      const resp: any = await this.oilCollectionService.getRoutes(params).toPromise();
      let routesData: any[] = [];
      if (resp && resp.routes) {
        this.totalRoutesRecords.set(resp.total || resp.routes.length || 0);
        routesData = resp.routes;
      } else if (resp && Array.isArray(resp)) {
        this.totalRoutesRecords.set(resp.length);
        routesData = resp;
      } else {
        this.totalRoutesRecords.set(0);
      }
      this.routesRowData.set(this.transformRoutes(routesData));
    } catch {
      this.totalRoutesRecords.set(0);
      this.routesRowData.set([]);
    } finally {
      this.loadingRoutesTable.set(false);
    }
  }

  /** Tier 8: replaces `_getRoutesData` + CollectionView wrapping. */
  private transformRoutes(arr: any[]): any[] {
    const totalRecords = this.totalRoutesRecords();
    const currentPage = this.routePage;
    const limit = this.routePageSize;
    return arr.map((item: any, i: number) => {
      const calculatedRouteNo = totalRecords - (limit * (currentPage - 1)) - i;
      const clientsCount = item.oil_collections?.length ?? 0;
      return {
        ...item,
        route_no_display: `Route #${calculatedRouteNo}`,
        status_label: item.status === '2' ? 'Completed' : 'In Progress',
        badge_class: item.status === '2' ? 'dot-complete' : 'dot-warning',
        clients_count: clientsCount,
        driver_name: item.driver?.name || 'Unassigned',
        date: this.formatDate(item.created_at || item.date_millis, 'MM/dd/yyyy')
      };
    });
  }

  // ── Form + PDF + email (kept intact, no Wijmo refs) ──────────────────────

  crearFormularioOilCollection(data?: any, accion?: string) {
    if (accion == 'edit') {
      this.oilCollectionForm = this.fb.group({
        created_at: [data ? data.created_at.split('T')[0] : '', Validators.required],
        gallons:    [data ? data.gallons : 0, Validators.required],
        notes:      data ? data.notes : ''
      });
    } else {
      this.oilCollectionForm = this.fb.group({
        gallons:    [''],
        notes:      [''],
        created_at: ['']
      });
    }
  }

  get gal_collected() {
    return this.oilCollectionForm.get('gallons');
  }

  getOilCertificateByEmail(_oilCollection: OilCollectionModel) {
    if (!this.usuarioService.usuario.signature) {
      return this.toastr.error('User Signature missing');
    }
    this.getPDF_File(_oilCollection);
  }

  /** Tier 8: the `save()` method that used `flexclone` + `wjcGridXlsx` is removed
   *  (dead code). Excel export is now handled by `exportCollections()` below. */
  deleteOilCollection(modal: any, _oilCollection: OilCollectionModel) {
    this.oilCollectionService.delete(_oilCollection._id).subscribe(
      (res: any) => {
        this.cargarDatos();
        this.toastr.success(res.msg);
        if (modal) modal.close();
      },
      () => this.toastr.error('Server Error')
    );
  }

  getPDF_File(_oilCollection: OilCollectionModel) {
    const min = 1718;
    const max = 34290;
    const x = Math.floor(Math.random() * (max - min + 1) + min);
    const pdf = this.pdfUtilities.downloadPDFOilRecovery(
      x,
      _oilCollection,
      this.usuarioService.usuario.signature
    );
    this.toSendPDF(pdf, _oilCollection);
  }

  getPDF_File_Download(_oilCollection: OilCollectionModel) {
    if (!this.usuarioService.usuario.signature) {
      return this.toastr.error('User Signature missing');
    }
    const min = 1718;
    const max = 34290;
    const x = Math.floor(Math.random() * (max - min + 1) + min);
    const pdf = this.pdfUtilities.downloadPDFOilRecovery(
      x,
      _oilCollection,
      this.usuarioService.usuario.signature
    );
    pdfMake.createPdf(pdf).download(`${_oilCollection.client_ident_GUI}`);
  }

  public toSendPDF(pdf: any, _oilCollection: OilCollectionModel) {
    const pdfDocGenerator = pdfMake.createPdf(pdf);
    pdfDocGenerator.getBlob((document: any) => {
      const file = new File(
        [document],
        `${_oilCollection.client_ident_GUI}.pdf`,
        { type: 'application/pdf' }
      );
      this.files_arr.push(file);
      this.setEmailData(_oilCollection.route.driver.email);
    });
  }

  async setEmailData(_clientEmail: string) {
    const _emails = [_clientEmail];
    try {
      const resp: any = await this.usuarioService.getAllAsync();
      if (resp.users) {
        resp.users.forEach((user: any) => {
          if (user.role === 'SALESMAN_ROLE' || user.role === 'SERVMAN_ROLE') {
            _emails.push(user.email);
          }
        });
      }
    } catch { /* ignore */ }
    this.sendingEmail(_emails.join());
  }

  sendingEmail(_emails: string) {
    const json = {
      email: _emails,
      bodyHtml: EmailTemplate.HTML_BODY_OilRecovery,
      attachment: _emails
    };
    this.zapierService
      .sentEmail(_emails, json.bodyHtml, this.files_arr)
      .subscribe(
        () => this.toastr.info('Sent Email'),
        () => this.toastr.error('Email Error')
      );
  }

  calcularWaste(valor: any) {
    this.resultCalculateWaste = this.calculatesWate.calculateWaste(parseInt(valor));
  }

  async openCollectionModal() {
    const records = await this.clientService.getAllAsync();
    const modalRef = this.modalService.open(RemoteOilCollectionModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.clients = records.clients;
    modalRef.result.then((shouldReload) => {
      if (shouldReload) this.cargarDatos();
    }, () => { });
  }

  async downloadReport(payload: any) {
    return await this.oilCollectionService
      .exportOilColletionsReportExcel(payload)
      .then((res: any) => {
        if (res.doc) {
          const link = document.createElement('a');
          link.href = res.doc;
          link.download = 'Oil-Collection-Report.xlsx';
          link.click();
        }
      });
  }

  openExportOilCollectionsReportExcel() {
    this.dialogsService.openExportOilCollectionsReportExcel()
      .then((filterData: any) => {
        if (filterData) {
          const payload = {
            startDate: filterData.startDate,
            endDate: filterData.endDate,
            clients: filterData.clientIds,
            sendTo: filterData.sendTo,
            sendByEmail: filterData.sendByEmail
          };
          this.downloadReport(payload);
          this.dialogsService.openFeedbackSuccess({
            title: 'Oil Collection Report',
            msg: 'The report was generated successfully'
          });
        }
      });
  }

  async exportCollections(): Promise<void> {
    if (!this.filter.start || !this.filter.end) {
      this.toastr.warning(
        'Please select a date range using the date filter before exporting.',
        'Date Required'
      );
      return;
    }
    this.loadingExport.set(true);
    try {
      const res: any = await this.oilCollectionService.exportCollectionsSimple(
        this.filter.start,
        this.filter.end
      );
      if (res?.doc) {
        const link = document.createElement('a');
        link.href = res.doc;
        link.download = `Collections-${this.filter.start}_to_${this.filter.end}.xlsx`;
        link.click();
      } else {
        this.toastr.error(res?.msg || 'Error generating the report.');
      }
    } catch (err) {
      this.toastr.error('Could not connect to the server. Please try again.');
    } finally {
      this.loadingExport.set(false);
    }
  }

  openAddRouteModal() {
    this.modalService.open(AddRouteModalComponent, { size: 'md', centered: true });
  }

  onCollectionsPageChange(newPage: number) {
    this.page = newPage;
    this.refreshData();
  }

  onRoutesPageChange(newPage: number) {
    this.routePage = newPage;
    this.refreshRoutesData();
  }
}
